import ComponentCoreRedirect from '@/components/core/Redirect.vue';
import apicore, { resolveUserToken } from '@/helpers/apicore';
import config from '@/helpers/config';
import { isDiscordId, isMatchId } from '@/helpers/matchId';
import { createRouter, createWebHistory } from 'vue-router';
const routes = [
  {
    path: '/',
    name: 'ViewHome',
    component: () => import(/* webpackChunkName: "CoreHome" */ '@/views/core/Home.vue'),
  },
  {
    path: '/staff',
    name: 'ViewContentStaff',
    component: () => import(/* webpackChunkName: "ContentGDPR" */ '@/views/content/Staff.vue'),
  },
  {
    path: '/gdpr',
    name: 'ViewContentGDPR',
    component: () => import(/* webpackChunkName: "ContentGDPR" */ '@/views/content/GDPR.vue'),
  },
  {
    path: '/cookies',
    name: 'ViewContentCookies',
    component: () => import(/* webpackChunkName: "ContentCookies" */ '@/views/content/Cookies.vue'),
  },
  {
    path: '/play',
    name: 'ViewGatherList',
    component: () => import(/* webpackChunkName: "GatherList" */ '@/views/gather/List.vue'),
  },
  {
    path: '/play/:token',
    name: 'ViewGatherInfo',
    component: () => import(/* webpackChunkName: "GatherInfo" */ '@/views/gather/Info.vue'),
    // Legacy /play/{discordId} links redirect to the canonical /play/{match_id}.
    // match_id (UUID v7) tokens pass straight through; only Discord snowflakes resolve.
    beforeEnter: async (to, from, next) => {
      const token = to.params.token;
      // by-token is browser-auth (Bearer); it can't resolve anonymously, so a logged-out
      // deep link goes to login instead of rendering a blank page (F10).
      if (!resolveUserToken()) {
        next({ name: 'ViewUserLogin' });
        return;
      }
      if (isMatchId(token)) {
        next();
        return;
      }
      if (isDiscordId(token)) {
        try {
          const params = {};
          if (config.apicore.guildId) params.guild_id = config.apicore.guildId; // R6: optional
          const response = await apicore.get('gathers/by-token/' + token, { params });
          const matchId = response && response.data && response.data.gather ? response.data.gather.match_id : undefined;
          if (isMatchId(matchId)) {
            next({ name: 'ViewGatherInfo', params: { token: matchId }, replace: true });
            return;
          }
        } catch (error) {
          // fall through to the 404 below — a stale/unknown Discord id is not resolvable
        }
        next({ name: 'ViewError404' });
        return;
      }
      // Neither a match_id nor a discordId — treat as not found.
      next({ name: 'ViewError404' });
    },
  },
  {
    path: '/user',
    name: 'ViewUserInfo',
    component: () => import(/* webpackChunkName: "UserInfo" */ '@/views/user/Info.vue'),
  },
  {
    path: '/user/login',
    name: 'ViewUserLogin',
    component: () => import(/* webpackChunkName: "UserLogin" */ '@/views/user/Login.vue'),
  },
  {
    path: '/user/loginOld',
    name: 'ViewUserLoginOld',
    component: () => import(/* webpackChunkName: "UserLoginOld" */ '@/views/user/LoginOld.vue'),
  },
  {
    path: '/user/created',
    name: 'ViewUserCreated',
    component: () => import(/* webpackChunkName: "UserCreate" */ '@/views/user/Created.vue'),
  },
  {
    path: '/user/create',
    name: 'ViewUserCreate',
    component: () => import(/* webpackChunkName: "UserCreate" */ '@/views/user/Create.vue'),
  },
  {
    path: '/user/reset',
    name: 'ViewUserForgot',
    component: () => import(/* webpackChunkName: "UserForgot" */ '@/views/user/Forgot.vue'),
  },
  {
    path: '/user/reset/:token',
    name: 'ViewUserReset',
    component: () => import(/* webpackChunkName: "UserReset" */ '@/views/user/Reset.vue'),
  },
  {
    path: '/user/discord',
    name: 'ViewUserDiscord',
    component: () => import(/* webpackChunkName: "UserDiscord" */ '@/views/user/Discord.vue'),
  },
  {
    path: '/user/steam',
    name: 'ViewUserSteam',
    component: () => import(/* webpackChunkName: "UserSteam" */ '@/views/user/Steam.vue'),
  },
  {
    path: '/error/404',
    name: 'ViewError404',
    component: () => import(/* webpackChunkName: "Error" */ '@/views/core/Error.vue'),
  },
  {
    path: '/error/500',
    name: 'ViewError500',
    component: () => import(/* webpackChunkName: "Error" */ '@/views/core/Error.vue'),
  },
  {
    path: '/:catchAll(.*)',
    component: ComponentCoreRedirect,
    props: { path: 'ViewError404' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
